import React, { useEffect, useRef, useState } from 'react'
import { getItem } from '../../../config/localStorage'
import defaultImage from '../../../assets/image/user-img-temp.jpg'
import moment from "moment";
import { Image } from 'react-bootstrap';

function TemplatelayoutOne(props) {
    const templateColorRef = useRef();
    const [personalDetails, setPersonalDetails] = useState(false);
    const [webPortProfile, setWebPortProfile] = useState(false);
    const [accomplishments, setAccomplishments] = useState(false);
    const [affiliations, setAffiliations] = useState(false);
    const [additionalInformation, setadditionalInformation] = useState(false);
    const [languages, setLanguages] = useState(false);
    const [certifications, setCertifications] = useState(false);
    const [interests, setInterests] = useState(false);
    const [hobbies, setHobbies] = useState(false);
    const profileDetailInfo = JSON.parse(getItem('profileData'));
    const profileImageInfo = getItem('profileImage');
    const experienceDetailInfo = JSON.parse(getItem('experienceData'));
    const educationDetailInfo = JSON.parse(getItem('educationData'));

    const SkillItemInfo = getItem('ratingItem'); // Skill list Item
    const skillListItem = SkillItemInfo !== null ? SkillItemInfo?.split('</p><p>') : '';

    const jobTitleInfo = getItem('jobTitle')?.trim();
    const getFirstjobTitle = jobTitleInfo !== null ? jobTitleInfo?.split(", ") : '';

    const summaryItemInfo = getItem('summaryItem') !== null ? getItem('summaryItem') : '';

    const personalDetailsInfo = getItem('personalDetailsData') !== null ? JSON.parse(getItem('personalDetailsData')) : '';
    const webPortProfileInfo = getItem('webPortProfileData') !== null ? JSON.parse(getItem('webPortProfileData')) : '';
    const accomplishmentsInfo = getItem('accomplishmentsData') !== null ? getItem('accomplishmentsData')?.split('</p><p>') : '';
    const affiliationsInfo = getItem('affiliationsData') !== null ? getItem('affiliationsData')?.split('</p><p>') : '';
    const additionalInfromationInfo = getItem('additionalInformationData') !== null ? getItem('additionalInformationData') : '';
    const languagesDataInfo = getItem('languagesData') !== null ? JSON.parse(getItem('languagesData')) : '';
    const certificationsDataInfo = getItem('certificationsData') ? JSON.parse(getItem('certificationsData')) : '';
    const interestsDataInfo = getItem('interestsData') !== null ? JSON.parse(getItem('interestsData')) : '';
    const hobbiesDataInfo = getItem('hobbiesData') !== null ? JSON.parse(getItem('hobbiesData')) : '';

    /* change color start */
    const defaultColor = props.colorDisplay ? props.colorDisplay : '163853';
    useEffect(() => {
        const style = templateColorRef.current.style;
        style.setProperty('--template-one-theme', `#${defaultColor}`);
        setPersonalDetails(getItem("personalDetails"));
        setWebPortProfile(getItem("webPortProfile"));
        setAccomplishments(getItem("accomplishments"));
        setAffiliations(getItem("affiliations"));
        setadditionalInformation(getItem("additionalInformation"));
        setLanguages(getItem("languages"));
        setCertifications(getItem("certifications"));
        setInterests(getItem("interests"));
        setHobbies(getItem("hobbies"))
    }, [defaultColor])
    /* change color end */

    return (
        <>
            <div className={`resume resume-temp-one resume-temp-responsive`} ref={templateColorRef}>
                <div className="resume_left">

                    {profileImageInfo ?
                        <div className="resume_profile">
                            <Image src={profileImageInfo !== '' ? profileImageInfo : defaultImage} alt="profile_pic" />
                        </div>
                        :
                        ""
                    }

                    <div className="resume_content">
                        {/* profile section start */}
                        {
                            profileDetailInfo ?
                                <div className="resume_item resume_contact_info">
                                    <div className="title">
                                        <p className="bold">Contact</p>
                                    </div>
                                    <ul>
                                        {
                                            profileDetailInfo.phone ? < li > <i className="fa fa-phone"></i> {profileDetailInfo.phone}</li> : ''
                                        }

                                        {
                                            profileDetailInfo.email ? <li> <i className="fa fa-envelope"></i> {profileDetailInfo.email}</li> : ''
                                        }

                                        {
                                            profileDetailInfo.city || profileDetailInfo.state || profileDetailInfo.country ? <li> <i className="fa fa-location-dot"></i> {profileDetailInfo.city + ', ' + profileDetailInfo.state + ', ' + profileDetailInfo.country}</li> : ''
                                        }
                                    </ul>
                                </div>
                                :
                                ''
                        }
                        {/* profile section end */}

                        {/* skill section start */}
                        {
                            skillListItem?.length > 0 ?
                                <div className="resume_item resume_skills">
                                    <div className="title">
                                        <p className="bold">Skill's</p>
                                    </div>
                                    <ul>
                                        {
                                            skillListItem.slice(0, 15).map((item, index) =>
                                                <li key={index} dangerouslySetInnerHTML={{ __html: item }}></li>
                                            )
                                        }
                                    </ul>
                                </div>
                                :
                                ''
                        }
                        {/* skill section end */}

                        {/* Certification section start */}
                        {
                            certifications && certificationsDataInfo?.length > 0 ?
                                <div className="resume_item resume_certification">
                                    <div className="title">
                                        <p className="bold">Certification</p>
                                    </div>
                                    <ul>
                                        {
                                            certificationsDataInfo.map((item, index) =>
                                                <li key={index}>
                                                    {item.certificationsName}
                                                    {item.certificationsYear && moment(item.certificationsYear).isValid() ? " In " + moment(item.certificationsYear).format('MM-DD-YYYY') : ''}
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                :
                                ''
                        }
                        {/* Certification section end */}

                        {/* webPortProfileInfo section start */}
                        {
                            webPortProfileInfo && webPortProfile ?
                                <div className="resume_item resume_portfolio">
                                    <div className="title">
                                        <p className="bold">Portfolio</p>
                                    </div>
                                    <ul>
                                        {webPortProfileInfo.wpLinkOne ? <li>{webPortProfileInfo.wpLinkOne}</li> : ''}
                                        {webPortProfileInfo.wpLinkTwo ? <li>{webPortProfileInfo.wpLinkTwo}</li> : ''}
                                        {webPortProfileInfo.wpLinkThree ? <li>{webPortProfileInfo.wpLinkThree}</li> : ''}
                                    </ul>
                                </div>
                                :
                                ""
                        }
                        {/* webPortProfileInfo section end */}

                        {/* hobbies section start */}
                        {
                            hobbies && hobbiesDataInfo?.length > 0 ?
                                <div className="resume_item resume_hobbies">
                                    <div className="title">
                                        <p className="bold">Hobbies</p>
                                    </div>
                                    <ul>
                                        {
                                            hobbiesDataInfo?.map((item, index) =>
                                                item !== '' ?
                                                    <li key={index}>{item}</li>
                                                    : ''
                                            )
                                        }
                                    </ul>
                                </div>
                                :
                                ""
                        }
                        {/* hobbies section end */}

                        {/* language section start */}
                        {
                            languages && languagesDataInfo?.length > 0 ?
                                <div className="resume_item resume_language">
                                    <div className="title">
                                        <p className="bold">Language</p>
                                    </div>
                                    <ul>
                                        {
                                            languagesDataInfo?.map((language, index) => (
                                                <li key={index}>{language?.languageTitle}</li>
                                            ))
                                        }
                                    </ul>
                                </div>
                                :
                                ''
                        }
                        {/* language section end */}

                        {/* interests section start */}
                        {
                            interests && interestsDataInfo?.length > 0 ?
                                <div className="resume_item resume_language">
                                    <div className="title">
                                        <p className="bold">Interests</p>
                                    </div>
                                    <ul>
                                        {
                                            interestsDataInfo.map((item, index) =>
                                                item !== '' ?
                                                    <li key={index}>{item}</li>
                                                    : ''
                                            )
                                        }
                                    </ul>
                                </div>
                                :
                                ""
                        }
                        {/* interests section end */}

                        {/* personal details section start */}
                        {
                            personalDetailsInfo && personalDetails ?

                                personalDetailsInfo?.dob || personalDetailsInfo?.nationality || personalDetailsInfo?.maritalStatus ?

                                    <div className="resume_item resume_personal_details">
                                        <div className="title">
                                            <p className="bold">Personal details</p>
                                        </div>
                                        <ul>
                                            {personalDetailsInfo?.dob && moment(personalDetailsInfo.dob).isValid() ? <li><strong>Date of Birth : </strong> {moment(personalDetailsInfo.dob).format('MM-DD-YYYY')} </li> : ''}
                                            {personalDetailsInfo?.nationality ? <li><strong>Nationality : </strong> {personalDetailsInfo.nationality} </li> : ''}
                                            {
                                                personalDetailsInfo?.maritalStatus && personalDetailsInfo?.maritalStatus?.toLowerCase() !== 'n/a' ?
                                                    <li><strong>Marital Status : </strong> {personalDetailsInfo.maritalStatus} </li> : ''
                                            }
                                        </ul>
                                    </div>
                                    :
                                    ""
                                :
                                ""
                        }
                        {/* personal details section end */}

                    </div>
                </div>

                <div className="resume_right">
                    <div className="resume_name_designation">
                        <div className="resume_name_designation">
                            {
                                profileDetailInfo ? <p className="bold"> {profileDetailInfo.firstName + ' ' + profileDetailInfo.lastName}</p> : ''
                            }
                            {
                                getFirstjobTitle?.length > 0 && getFirstjobTitle[0] ? <p className="regular text-uppercase">{getFirstjobTitle[0]}</p> : ''
                            }

                        </div>
                    </div>

                    {/* profile section start */}
                    {
                        summaryItemInfo != null && summaryItemInfo ?
                            <div className="resume_item resume_about">
                                <div className="title">
                                    <p className="bold">Profile</p>
                                </div>
                                <div className="profile_summary" dangerouslySetInnerHTML={{ __html: summaryItemInfo }}></div>
                            </div>
                            : ''
                    }
                    {/* profile section end */}

                    {/* experience section start */}
                    {
                        experienceDetailInfo != null && experienceDetailInfo?.length > 0 ?
                            <div className="resume_item resume_work">
                                <div className="title">
                                    <p className="bold">Work Experience</p>
                                </div>
                                <ul>
                                    {
                                        experienceDetailInfo.map((item, index) =>
                                            <li key={index + 1}>
                                                <div className='heading-date-part'>
                                                    <div className='heading-part'>{item.jobTitle}</div>
                                                    <div className='date-part'>
                                                        {
                                                            item.startDate && moment(item.startDate).isValid() ? moment(item.startDate).format('MMM, YYYY') : ''
                                                        }
                                                        {
                                                            item.endDate && moment(item.endDate).isValid() ? " - " + moment(item.endDate).format('MMM, YYYY') : ' - Present'
                                                        }
                                                    </div>
                                                </div>
                                                <div className='location-desc-part'>
                                                    {
                                                        item?.employer ?
                                                            <p className='location-part'><strong>{item?.employer}</strong></p> : ''
                                                    }
                                                    {
                                                        item?.location !== 'N/A' ?
                                                            <p className='location-part'>{item?.location}</p> : ''
                                                    }
                                                    {
                                                        item.jobDescription ?
                                                            <p className='desc-part'>{item.jobDescription}</p> : ''
                                                    }
                                                </div>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>

                            :

                            ''
                    }
                    {/* experience section end */}

                    {/* education section start */}
                    {
                        educationDetailInfo != null && educationDetailInfo?.length > 0 ?
                            <div className="resume_item resume_education">
                                <div className="title">
                                    <p className="bold">Education</p>
                                </div>
                                <ul>
                                    {
                                        educationDetailInfo.map((item, index) =>
                                            <li key={index + 1}>
                                                <div className='heading-date-part'>
                                                    <div className='heading-part'>{item.schoolDegree} ({item.schoolName})</div>
                                                    <div className='date-part'>
                                                        {item.schoolYearOfCompletion ? item.schoolYearOfCompletion : ''}
                                                    </div>
                                                </div>
                                                <div className="info">
                                                    {
                                                        item?.schoolFieldOfStudy !== 'N/A' ?
                                                            <p className='desc-part'>{item?.schoolFieldOfStudy}</p> : ''
                                                    }

                                                    {
                                                        item?.schoolLocation !== 'N/A' ?
                                                            <p className='desc-part'>{item?.schoolLocation}</p> : ''
                                                    }
                                                </div>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>

                            :

                            ''
                    }
                    {/* education section end */}

                    {/* accomplishment section start */}
                    {
                        accomplishmentsInfo != null && accomplishments && accomplishmentsInfo?.length > 0 ?
                            <div className="resume_item resume_accomplishment">
                                <div className="title">
                                    <p className="bold">Accomplishment</p>
                                </div>
                                <ul>
                                    {
                                        accomplishmentsInfo.map((item, index) =>
                                            <li key={index + 1}>
                                                <div className="date" dangerouslySetInnerHTML={{ __html: item }}></div>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>

                            :

                            ''
                    }
                    {/* accomplishment section end */}

                    {/* affiliation section start */}
                    {
                        affiliationsInfo != null && affiliations && affiliationsInfo?.length > 0 ?
                            <div className="resume_item resume_affiliation">
                                <div className="title">
                                    <p className="bold">Affiliation</p>
                                </div>
                                <ul>
                                    {
                                        affiliationsInfo.map((item, index) =>
                                            <li key={index + 1}>
                                                <div className="date" dangerouslySetInnerHTML={{ __html: item }}></div>
                                            </li>
                                        )
                                    }
                                </ul>
                            </div>

                            :

                            ''
                    }
                    {/* affiliation section end */}

                    {/* ADDITIONAL INFORMATION section start */}
                    {
                        additionalInfromationInfo != null && additionalInformation && additionalInfromationInfo?.length > 0 ?
                            <div className="resume_item resume_affiliation">
                                <div className="title">
                                    <p className="bold">Additional Infromation</p>
                                </div>
                                <div className="date" dangerouslySetInnerHTML={{ __html: additionalInfromationInfo }}></div>
                            </div>

                            :

                            ''
                    }
                    {/* ADDITIONAL INFORMATION section end */}

                </div>
            </div >
        </>
    )
}

export default TemplatelayoutOne
